var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer_panel_wrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"object-fit":"contain !important","height":"initial !important"},attrs:{"src":"https://arabfor.sa/new-design/img/offer.26bf3c0b.png","alt":_vm.panelImage.name}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }